import type { Skill } from './types';
import { previewSkill } from './preview';

const skills: Skill[] = [previewSkill];

export function getSkills(): Skill[] {
  return skills;
}

export function getSkill(id: string): Skill | undefined {
  return skills.find((s) => s.id === id);
}

export async function callSkill(skillId: string, operationId: string, params: Record<string, unknown>): Promise<unknown> {
  const skill = getSkill(skillId);
  if (!skill) throw new Error(`Skill not found: ${skillId}`);
  return skill.execute(operationId, params);
}

export type { Skill, SkillOperation, SkillParam } from './types';
export { previewSkill } from './preview';
